<!-- FC = FARMACIA CENTRAL -->

<template>
  <div>
    <v-navigation-drawer v-model="drawer" app color="#222d32" class="notPrint">
      <v-list v-if="$store.getters.nivel === 6" dense>
        <v-list-item v-for="linkItem in sidebarLinkItensUnidades" :key="linkItem.text" :to="linkItem.link">
          <v-list-item-action>
            <v-icon color="#fff">{{ linkItem.icon }}</v-icon>
          </v-list-item-action>

          <v-list-item-content>
            <v-list-item-title class="title-menu text-wrap" style="min-width: 160px;">
              {{ linkItem.text }}
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>

    <v-app-bar app color="#3cbc62" dark class="notPrint">
      <v-app-bar-nav-icon @click.stop="drawer = !drawer"></v-app-bar-nav-icon>
      <v-toolbar-title>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn dark icon v-bind="attrs" v-on="on" @click="abrirModal()">
              <v-icon>mdi-autorenew</v-icon>
            </v-btn>
          </template>
          <span>Alterar Unidade</span>
        </v-tooltip>
        SIGU - {{ verificaNome($store.getters.nomeUnidade) }}
      </v-toolbar-title>
      <v-spacer></v-spacer>

      <v-menu v-model="menu" bottom left>
        <template v-slot:activator="{ on, attrs }">
          <v-btn dark icon v-bind="attrs" v-on="on">
            <v-badge :content="newChamado.length" :value="newChamado.length" color="red" overlap>
              <v-icon>mdi-bell</v-icon>
            </v-badge>
          </v-btn>
        </template>

        <v-row v-for="(item, i) in newChamado" :key="i">
          <v-card aria-selected="true" class="v-list-item" role="listitem" tabindex="0" @click="routerNotification(item.linkRouterNotification)">
            <v-icon>{{ item.icon }}</v-icon>
            <v-card-text>{{ item.textCard }}</v-card-text>
          </v-card>
        </v-row>
      </v-menu>

      <v-chip class="ma-2" color="fff" outlined pill>
        {{ $store.getters.nome }}
      </v-chip>

      <v-menu bottom left>
        <template v-slot:activator="{ on, attrs }">
          <v-btn dark icon v-bind="attrs" v-on="on">
            <button>Conf</button>
          </v-btn>
        </template>
        <v-list>
          <div class="v-list-item-group" role="listbox">
            <div aria-disabled="true" aria-selected="true" class="v-list-item" role="listitem" tabindex="-1" @click="showProfile">
              Perfil
            </div>
            <div aria-disabled="true" aria-selected="true" class="v-list-item" role="listitem" tabindex="-1" @click="logout">
              Sair
            </div>
          </div>
        </v-list>
      </v-menu>
    </v-app-bar>

    <v-main>
      <v-container class="fill-height" fluid>
        <v-row align="center" justify="center">
          <slot></slot>
        </v-row>
      </v-container>
    </v-main>

    <ModalCustomSize
      :modalSize="modalCustomSizeApp.size"
      :isTheModalOpen="modalCustomSizeApp.isOpen"
      :modalButtonText="modalCustomSizeApp.buttonText"
      :modalFormTitle="modalCustomSizeApp.formTitle"
      :modalType="modalCustomSizeApp.modalType"
      :isCancelDisabled="modalCustomSizeApp.isCancelDisabled"
      :isLoadingRequestDisable="modalCustomSizeApp.isLoadingRequestDisable"
      :isModalButtonVisible="modalCustomSizeApp.isButtonsVisible"
      v-on:formmodal-close="modalCustomSizeApp.isOpen = false"
      v-on:formmodal-action="onFormModalAction"
    >
      <v-form v-model="isFormValid">
        <v-row>
          <v-col cols="12">
            <v-autocomplete label="Unidades" :items="listaUnidades" v-model="unidadeSelecionada" :rules="[rules.required]"> </v-autocomplete>
          </v-col>
        </v-row>
      </v-form>
    </ModalCustomSize>
  </div>
</template>

<script>
import ModalCustomSize from "@/components/ModalCustomSize.vue";
import { mapState } from "vuex";

export default {
  components: {
    ModalCustomSize,
  },

  watch: {
    menu() {
      if (this.newChamado.length > 0) {
        if (!this.menu) {
          this.newChamado = [];
          this.statusNotify = false;
        } else {
          this.statusNotify = true;
        }
      }
    },

    newChamado() {
      if (this.newChamado) {
        this.statusNotify = false;
      } else {
        this.statusNotify = true;
      }
    },

    isFormValid() {
      this.modalCustomSizeApp.isButtonsDisabled = !this.isFormValid;
    },

    unidadeSelecionada() {
      if (this.unidadeSelecionada) {
        const unidade = this.listaUnidades.filter((unidade) => unidade.value == this.unidadeSelecionada);

        this.modalCustomSizeApp.actualEdit.numeroUnidade = unidade[0].value;
        this.modalCustomSizeApp.actualEdit.nomeUnidade = unidade[0].text;
      }
    },
  },
  props: {
    source: String,
  },
  computed: {
    ...mapState({
      currentUser: "currentUser",
    }),
  },
  data: () => ({
    menu: null,
    newChamado: [],
    dialog: false,
    drawer: null,
    statusNotify: true,
    sidebarLinkItensUnidades: [
      {
        icon: "mdi-package-variant",
        text: "Receber Produtos",
        link: "/receberProduto",
      },
      {
        icon: "mdi-note-plus-outline",
        text: "Solicitar Produtos",
        link: "/solicitarProdutos",
      },
      {
        icon: "mdi-medical-cotton-swab",
        text: "Dispensas Teste Rápido",
        link: "/dispensakit",
      },
      {
        icon: "mdi-domain",
        text: "Setor",
        link: "/setorUnidade",
      },
      {
        icon: "mdi-archive-arrow-up",
        text: "Dispensa Setor",
        link: "/dispensaSetor",
      },
      {
        icon: "mdi-receipt-text-check",
        text: "Aprovar transferência para unidade",
        link: "/aprovardispensaunidade",
      },
      {
        icon: "mdi-receipt-text-send",
        text: "Transferências entre Unidades",
        link: "/dispensaunidade",
      },
      {
        icon: "mdi-account-group-outline",
        text: "Pacientes",
        link: "/pacientes",
      },
      // {
      //   icon: "mdi-account-cog",
      //   text: "Dispensa Paciente",
      //   link: "/dispensaPaciente",
      // },
      {
        icon: "mdi-briefcase-account-outline",
        text: "Dispensa paciente unidade",
        link: "/dispensaPacienteUnidade",
      },
      {
        icon: "mdi-file-tree",
        text: "Subestoque",
        link: "/subestoque",
      },
      {
        icon: "mdi-source-repository-multiple",
        text: "Dispensa Subestoque",
        link: "/dispensaSubestoque",
      },
      {
        icon: "mdi-view-grid-plus-outline",
        text: "Kit",
        link: "/kit",
      },
      {
        icon: "mdi-file-table",
        text: "Produtos Padronizados",
        link: "/produtosSistemaUnidade",
      },
      {
        icon: "mdi-square-edit-outline",
        text: "Produtos no Estoque",
        link: "/produtosUnidade",
      },
      {
        icon: "mdi-database",
        text: "Registro de Estoque",
        link: "/estoqueUnidade",
      },
      {
        icon: "mdi-file-move",
        text: "Relatório de Saida",
        link: "/relatorioSaida",
      },
      {
        icon: "mdi-chart-bar",
        text: "Placar de Movimentação Mensal/Anual",
        link: "/relatorioSaidaMensal",
      },
      {
        icon: "mdi-calendar-clock",
        text: "Relatório de Alterações Estoque",
        link: "/relatorioalteracoesunidade",
      },
      {
        icon: "mdi-file-clock",
        text: "Relatório de Entradas Nota Unidade",
        link: "/relatorioentradasunidade",
      },
      {
        icon: "mdi-clipboard-text-clock",
        text: "Relatório Dispensas Teste Rápido Unidade",
        link: "/relatoriodispensakitsunidade",
      },
      {
        icon: "mdi-numeric-1-box-multiple-outline",
        text: "Importar Nota",
        link: "/importarNota",
      },
    ],

    isFormValid: false,

    modalCustomSizeApp: {
      size: "1000",
      isOpen: true,
      buttonText: "Selecionar",
      formTitle: "Selecionar Unidade",
      isEdit: false,
      isLoadingRequestDisable: false,
      isButtonsVisible: true,
      isButtonsDisabled: false,
      actualEdit: {
        numeroUnidade: null,
        nomeUnidade: null,
      },
    },

    unidadeSelecionada: null,
    listaUnidades: [
      {
        text: "FARMACIA CENTRAL",
        value: 123,
      },
      {
        text: "FARMACIA CENTRAL - SAÚDE MENTAL",
        value: 124,
      },
      {
        text: "FARMACIA CENTRAL - PID",
        value: 125,
      },
    ],

    rules: {
      required: (value) => !!value || "Requer o campo!",
    },
  }),

  created() {
    this.initialize();
  },

  methods: {
    initialize() {
      if (this.$store.getters.nivel === 6) {
        this.modalCustomSizeApp.isOpen = true;
      } else {
        this.modalCustomSizeApp.isOpen = false;
      }
    },
    logout() {
      this.$store.dispatch("logout");
      this.$router.push("/login");
    },
    verificaNome(nomeUnidade) {
      switch (nomeUnidade) {
        case "":
          return "Nenhuma unidade selecionada";
        case null:
          return "Nenhuma unidade selecionada";
        case nomeUnidade:
          return nomeUnidade;
      }
    },
    showProfile() {
      this.$router.push("/perfil");
    },
    routerNotification(linkRouterNotification) {
      this.$router.push(linkRouterNotification);
    },

    abrirModal() {
      this.modalCustomSizeApp.isOpen = true;
      this.modalCustomSizeApp.isButtonsDisabled = !this.isFormValid;

      this.modalCustomSizeApp.actualEdit.numeroUnidade = null;
    },

    async onFormModalAction() {
      await this.$store.dispatch("setNumeroEndereco", this.modalCustomSizeApp.actualEdit.numeroUnidade);
      await this.$store.dispatch("setNomeUnidade", this.modalCustomSizeApp.actualEdit.nomeUnidade);
      this.modalCustomSizeApp.isOpen = false;
      this.$router.go();
    },
  },
};
</script>

<style scoped>
.title-menu {
  color: #fff;
}
.print {
  display: none;
}
@media print {
  .notPrint {
    display: none;
  }
  .print {
    display: block;
  }
}
</style>
